<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <div class="side-frame">
        <span class="side-frame-text"
          >订单编号：{{
            formData.orderNo ? formData.orderNo : '自动生成'
          }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span class="side-frame-text"
          >状态：{{
            formData.orderStatusName ? formData.orderStatusName : '新增'
          }}</span
        >
      </div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="客户" prop="custCode">
            <dict-select
              v-model="formData.custCode"
              url="/master/customer/info/select"
              placeholder="请选择客户"
              filterable
              clearable
              style="width:100%"
              :disabled="disabled"
              :selectedLabel.sync="formData.custName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="负责机构" prop="orgCode">
            <org-cascader
              :valueString.sync="formData.orgAllCode"
              :lastValue.sync="formData.orgCode"
              :pathLabels.sync="formData.orgParentFullName"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单类型" prop="orderType">
            <dict-select
              clearable
              v-model="formData.orderType"
              placeholder="请选择订单类型"
              default
              filterable
              style="width:100%"
              :body="selectOrderType"
              :disabled="disabled"
              :selectedLabel.sync="formData.orderTypeName"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="业务类型" prop="bizType" size="small">
            <dict-select
              clearable
              v-model="formData.bizType"
              placeholder="请选择业务类型"
              default
              filterable
              size="small"
              style="width:100%"
              :body="selectBizType"
              :disabled="disabled"
              :selectedLabel.sync="formData.bizTypeName"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运输模式" prop="transportMode" size="small">
            <dict-select
              clearable
              v-model="formData.transportMode"
              placeholder="请选择运输模式"
              default
              filterable
              size="small"
              style="width:100%"
              :body="selectTransportMode"
              :selectedLabel.sync="formData.transportModeName"
              :disabled="disabled"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户托运日期" size="small">
            <el-date-picker
              type="date"
              v-model="formData.orderDate"
              placeholder="选择客户托运日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              size="small"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ERP/WMS单号" prop="bizBillNo" size="small">
            <el-input
              v-model="formData.bizBillNo"
              type="text"
              size="small"
              clearable
              :disabled="disabled"
              placeholder="请输入ERP/WMS单号"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户订单号/客户运单号" prop="wayBillNo" size="small">
            <el-input
              v-model="formData.wayBillNo"
              type="text"
              size="small"
              clearable
              placeholder="请输入客户订单号/客户运单号"
              :disabled="disabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售订单号" size="small">
            <el-input
              v-model="formData.orderSoNo"
              clearable
              type="text"
              size="small"
              placeholder="请输入销售订单号"
              :disabled="disabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车型需求" prop="vehicleModel" size="small">
            <dict-select
              clearable
              v-model="formData.vehicleModel"
              placeholder="请选择车型"
              style="width: 100%"
              default
              filterable
              size="small"
              :body="selectVehicleModel"
              :selectedLabel.sync="formData.vehicleModelName"
              :disabled="disabled"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车长需求" prop="vehicleLength" size="small">
            <dict-select
              clearable
              v-model="formData.vehicleLength"
              placeholder="请选择车长"
              style="width: 100%"
              default
              filterable
              size="small"
              :body="selectVehicleLength"
              :selectedLabel.sync="formData.vehicleLengthName"
              :disabled="disabled"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="载重需求（吨）" prop="vehicleLoad" size="small">
            <el-input-number
              v-model="formData.vehicleLoad"
              style="width:100%"
              :min="0"
              clearable
              :controls="false"
              :precision="2"
              size="small"
              :disabled="disabled"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="载方需求（立方米）"
            prop="vehicleVolume"
            size="small"
            clearable
          >
            <el-input-number
              v-model="formData.vehicleVolume"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="2"
              size="small"
              clearable
              :disabled="disabled"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="提货要求" size="small">
            <el-checkbox v-model="formData.pickupSign" :disabled="disabled"
              >签到</el-checkbox
            >
            <el-checkbox v-model="formData.pickupBill" :disabled="disabled"
              >单证</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="送货要求" size="small">
            <el-checkbox v-model="formData.receiveSign" :disabled="disabled"
              >签到</el-checkbox
            >
            <el-checkbox v-model="formData.receiveBill" :disabled="disabled"
              >单证</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否返程" size="small">
            <el-checkbox v-model="formData.isBack" :disabled="disabled"
              >需要返程</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="合同订单" size="small">
            <el-checkbox
              v-model="formData.isMatchingContract"
              :disabled="disabled"
              >合同订单必须匹配</el-checkbox
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            label="预计提货开始时间"
            prop="pickDatetimeBegin"
            size="small"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.pickDatetimeBegin"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择提货日期"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="预计提货截止时间"
            prop="pickDatetimeEnd"
            size="small"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.pickDatetimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择预计提货截止时间"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="预计送达开始时间"
            prop="receiveDatetimeBegin"
            size="small"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.receiveDatetimeBegin"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择预计送达开始时间"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="预计送达截止时间"
            prop="receiveDatetimeEnd"
            size="small"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.receiveDatetimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择预计送达截止时间"
              :disabled="disabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backDialogVisible: false,
      selectOrderType: { type: 'orderType' },
      selectBizType: { type: 'bizType' },
      selectTransportMode: { type: 'transportMode' },
      selectVehicleModel: { type: 'vehicleModel' },
      selectVehicleLength: { type: 'vehicleLength' },
      rules: {
        custCode: [
          { required: true, message: '请选择客户', trigger: 'change' },
        ],
        orderType: [
          { required: true, message: '请选择订单类型', trigger: 'change' },
        ],
        bizType: [
          { required: true, message: '请选择业务类型', trigger: 'change' },
        ],
        transportMode: [
          { required: true, message: '请选择运输模式', trigger: 'change' },
        ],
        orgCode: [
          { required: true, message: '请选择负责机构', trigger: 'change' },
        ],
        orderStatus: [
          { required: true, message: '请选择订单状态', trigger: 'change' },
        ],
        settlementStatus: [
          { required: true, message: '请选择结算状态', trigger: 'change' },
        ],
        bizBillNo: [
          { required: true, message: '请输入ERP/WMS单号', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    matchData() {
      return {
        custCode: this.formData.custCode,
        orderType: this.formData.orderType,
        bizType: this.formData.bizType,
        transportMode: this.formData.transportMode,
        vehicleModel: this.formData.vehicleModel,
        vehicleLength: this.formData.vehicleLength,
        vehicleLoad: this.formData.vehicleLoad,
        vehicleVolume: this.formData.vehicleVolume,
        isBack: this.formData.isBack,
      }
    },
  },
  watch: {
    'formData.custCode'() {
      const custCode = this.formData.custCode
      this.$eventBus.$emit('splitCustCodeChange', custCode)
    },
    matchData: {
      deep: true,
      handler() {
        this.$eventBus.$emit('resetContract')
      },
    },
  },
  methods: {
    reset() {
      this.formData = {
        pickupSign: false,
        pickupBill: false,
        receiveSign: false,
        receiveBill: false,
        isBack: false,
        isMatchingContract: false,
      }
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
    },
    async getFormData() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.$message.error('有必输字段未填写，请检查')
        return
      }
      return this.formData
    },
  },
}
</script>
